import { formatNumberWithComma } from '../../../../../../utils/format-numbers.utils';
import Label from '../../../../../ui/label';
import { RowData } from '../../../../../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.state';

interface Props {
    isPreview?: boolean;
    inputsBySalaryRank: RowData[]
    selectedCoverageTypeState: string | undefined
}

export default function SalaryRank({ isPreview, inputsBySalaryRank, selectedCoverageTypeState }: Props) {
    
    return (
        <div className='flex flex-col bg-white overflow-hidden'>
            <div className='p-2 flex items-center justify-between border-b border-[#186cb2]/20 bg-[#186cb2]/10'>
                <div className='space-y-1'>
                    <Label
                        label={selectedCoverageTypeState ?? ""}
                        fontSize="text-xs"
                        fontWeight={`${isPreview ? 'text-xs font-semibold text-gray-800' : 'text-white'}`}
                    />
                    {!isPreview && (
                        <p className="text-xs text-white">
                            Enter the corresponding coverage amount for each designation.
                            You can add multiple rows as needed.
                        </p>
                    )}
                </div>
            </div>
            <div className="overflow-x-auto bg-white p-2">
                <table className="w-full border-collapse">
                    <thead>
                        <tr className="bg-gray-100 text-black">
                            <th className="border font-medium text-xs px-2 py-2 text-left">Salary Multiplier</th>
                            <th className="border font-medium text-xs px-2 py-2 text-left">Average Salary</th>
                            <th className="border font-medium text-xs px-2 py-2 text-left">Computation</th>
                            <th className="border font-medium text-xs px-2 py-2 text-left">Designation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {inputsBySalaryRank.map((input, index) => (
                            <tr key={index}> 
                                <td className="border p-2 text-xs">{input.multiplierLabel}</td>
                                <td className="border p-2 text-xs">{formatNumberWithComma(input.salary)}</td>
                                <td className="border p-2 text-xs">{formatNumberWithComma(input.result)}</td>
                                <td className="border p-2 text-xs">{input.designation}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
